(function () {
    // Mark the current nav link for styling / a11y.
    var links = document.querySelectorAll('.mith-nav-menu a[href]');
    var path = window.location.pathname.replace(/\/$/, '') || '/';

    for (var i = 0; i < links.length; i++) {
        var linkPath = links[i].pathname.replace(/\/$/, '') || '/';
        if (linkPath === path) {
            links[i].setAttribute('aria-current', 'page');
        }
    }
}());
